import useScrollPosition from 'Hooks/useScrollPosition';

import CaretDownWideThin from 'Icons/caretGsd.svg?react';

interface IScrollToTopButton {
    translations: {
        scrollToTop: string;
    };
}

const ScrollToTopButton = ({ translations }: IScrollToTopButton) => {
    const isBrowser = typeof window !== 'undefined';
    const scrollPosition = useScrollPosition();
    const threshold = isBrowser ? window.innerHeight * 1.5 : null;
    const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    return (
        <button
            type="button"
            onClick={() => scrollToTop()}
            className={`fixed bottom-[5%] right-[calc(5%_+_var(--scrollbar-width))] z-10 flex h-9 w-9 origin-right items-center justify-center rounded-full bg-silverLight opacity-0 transition-[visibility,_opacity] duration-layout lg:h-14 lg:w-14 ${
                scrollPosition > threshold ? 'visible opacity-100' : 'invisible'
            }`}
        >
            <span className="sr-only">{translations.scrollToTop}</span>
            <CaretDownWideThin className="h-4 w-4 -rotate-90 lg:h-6 lg:w-6" />
        </button>
    );
};

export default ScrollToTopButton;
